/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingEntityRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("BillingEntityRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return BillingEntityRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<BillingEntityRegexQueryOperator>): BillingEntityRegexQueryOperator {
        let obj = Object.assign(new BillingEntityRegexQueryOperator(), model);
        BillingEntityRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingEntityRegexQueryOperator>): BillingEntityRegexQueryOperator {
        if (!model) return null;
        return BillingEntityRegexQueryOperator.newInstance(<BillingEntityRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingEntityRegexQueryOperator) {
        if (!obj) return;

        models.BillingEntityRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingEntityRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingEntityRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.billing_entity) {
            models.Regex.fixupPrototype(this.billing_entity);
        }
    }

    /**
     * Include response that has the given billing_entity pattern
     */
    billing_entity: models.Regex;

}
